import { EventNames } from '../EventNames';

export const lockHeader = (active: boolean, forceOpen?: boolean) => {
    window.dispatchEvent(
        new CustomEvent(EventNames.ScrollLockChange, {
            detail: {
                active: active,
                forceOpen: forceOpen === true
            }
        })
    );
};
